import { useStore } from 'vuex';
import { caClick, caPageStart, initClickReport } from '@/utils/ca';

/**
 * @description 埋点Hooks
 * @author Wynne
 * @date 2021-03-17
 */
export const useReport = (pageId:string, param?:Record<string, string | number | boolean>) => {
  const store = useStore();
  // 获取用户信息
  store.dispatch('GetUserInfo').then((res?:AccountAPI.Response.ILogin) => {
    // 初始化PV上报
    caPageStart(pageId, res?.user_info.id, !!res, param);
    // 初始化点击上报
    initClickReport(pageId, res?.user_info.id, !!res, param);
  }).catch(() => {
    console.log('获取用户信息失败');
  });

  // 手动触发点击上报
  const clickReport = (buried:string) => {
    store.dispatch('GetUserInfo').then((res) => {
      caClick(buried, pageId, res?.user_info.id ?? '', !!res, param || {});
    }).catch((err) => console.log(err));
  };
  return { clickReport };
};


